<div class="d-block">
  <ul class="nav nav-secondary" role="leaderboardnav" aria-label="leaderboard nav">
    <div class="games-nav container justify-content-start">
      <a
        class="nav-item leaderboard-nav-item"
        [routerLink]="['/games/' + routeLink]"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.screenreader' | translate }}"
      >
        <label>{{ routeLink + '.nav.featured' | translate: { fgbdefault: 'Play' } }}</label>
      </a>
      <a
        class="nav-item leaderboard-nav-item"
        [routerLink]="['/games/' + routeLink + '/leaderboard']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.leaderboard.screenreader' | translate }}"
      >
        <label>{{ 'games.nav.' + routeLink + '.leaderboard' | translate: { fgbdefault: 'Leaderboard' } }}</label>
      </a>
      <a
        *ngIf="isRulesEnabled"
        class="nav-item leaderboard-nav-item"
        [routerLink]="['/games/' + routeLink + '/how-to-play']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.rules.screenreader' | translate }}"
      >
        <label>{{ 'games.nav.' + routeLink + '.how.to.play' | translate: { fgbdefault: 'How to Play' } }}</label>
      </a>
    </div>
  </ul>
</div>
